"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MethodConfig_1 = __importDefault(require("../../interface/MethodConfig"));
const config_1 = __importDefault(require("../../config"));
class BtcConfirmGuarantee {
    constructor() {
        this.requireLevel = config_1.default.REQUIRE_LEVEL.COMPLETELY;
        this.id = 'bifi.btcConfirmGuarantee';
        this.entryPointID = 'bifi.bitcoin';
    }
    getMethodProps() {
        return [new MethodConfig_1.default('bifi.btcConfirmGuarantee', [], 'bifi.bitcoin')];
    }
    proccessCallResponse(responses) {
        return (responses[0] || [])[0];
    }
}
exports.default = BtcConfirmGuarantee;
;
//# sourceMappingURL=BtcConfirmGuarantee.js.map